module.exports = __webpack_public_path__ + "assets/img/25_391.94334dbb.jpg";